import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const { t, lang } = useLang();
  const [post, setPost] = useState(null);
  useEffect(() => { (async () => { try { const { data } = await api.get(`/blog/${slug}`); setPost(data); } catch {} })(); }, [slug]);
  if (!post) return <div className="min-h-screen flex items-center justify-center"><div className="h-10 w-10 animate-spin rounded-full border-4 border-gold border-t-transparent" /></div>;
  const locale = lang === "en" ? "en-US" : "fr-FR";
  const title = lang === "en" && post.title_en ? post.title_en : post.title;
  const excerpt = lang === "en" && post.excerpt_en ? post.excerpt_en : post.excerpt;
  const content = lang === "en" && post.content_en ? post.content_en : post.content;

  return (
    <article className="bg-ivory">
      <div className="relative h-[45vh]">
        <img src={post.image} alt={post.title} className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-navy/60" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-3xl mx-auto w-full px-4 sm:px-8 lg:px-16 pb-10">
            <span className="font-mono text-xs uppercase tracking-widest text-gold-light">{post.category}</span>
            <h1 className="mt-3 font-serif text-3xl sm:text-5xl font-bold text-white text-shadow-lg">{title}</h1>
            <p className="mt-3 text-white/70 text-sm">{post.author} · {new Date(post.created_at).toLocaleDateString(locale)}</p>
          </div>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-16 py-12">
        <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-navy mb-8"><ArrowLeft className="h-4 w-4" /> {t("pages.blog.allArticles")}</Link>
        <p className="text-lg text-navy font-medium mb-6">{excerpt}</p>
        <div className="prose max-w-none text-slate-700 leading-relaxed [&_p]:mb-4" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </article>
  );
}
